module.exports = __webpack_public_path__ + "img/record_to_solvet_the_problem_active.68b2d216.svg";